import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../store'
import { selectSelf } from '..'

export const selectMenuState = createSelector(selectSelf, (state: RootState) => state.menu)
